import { FC } from "react";
import Card from "react-bootstrap/Card";
import { FaInfoCircle } from "react-icons/fa";

export const AllUserRolePermissionsOverviewCard: FC = () => (
    <Card>
        <Card.Body>
            <Card.Title className="mb-3">
                <FaInfoCircle /> Roles
            </Card.Title>
            <Card.Subtitle>User</Card.Subtitle>
            <ul>
                <li>
                    System-wide
                    <ul>
                        <li>Testing types: list</li>
                    </ul>
                </li>

                <li>
                    When added to a report, the following permission apply
                    <ul>
                        <li>Report invites: list</li>
                        <li>Report read receipts: list</li>
                        <li>Report vulnerabilities: list</li>
                        <li>Report vulnerability actions: list, create, update, delete</li>
                        <li>Report vulnerability retest requests: list, create</li>
                    </ul>
                </li>
            </ul>
            <Card.Subtitle>Tester</Card.Subtitle>
            <ul>
                <li>
                    System-wide
                    <ul>
                        <li>Contacts: list, create, update, delete</li>
                        <li>Companies: list</li>
                        <li>Reports: list, create, update</li>
                        <li>Report invites: list, create, delete</li>
                        <li>Report read receipts: list</li>
                        <li>Report vulnerabilities: list, create, update, delete</li>
                        <li>Report vulnerability actions: list, create, update, delete</li>
                        <li>Report vulnerability retest requests: list, create, update, delete</li>
                        <li>Report vulnerability client notifications: create</li>
                        <li>Master vulnerabilities: list, create, update, delete</li>
                        <li>Testing types: list, create, update, delete</li>
                        <li>Users: list</li>
                    </ul>
                </li>
            </ul>
            <Card.Subtitle>Consultant</Card.Subtitle>
            <ul>
                <li>
                    System-wide
                    <ul>
                        <li>Users: list</li>
                        <li>Contacts: list, create, update, delete</li>
                        <li>Master vulnerabilities: list, create, update, delete</li>
                        <li>Testing types: list, create, update, delete</li>
                    </ul>
                </li>

                <li>
                    When added to a report, the following permission apply
                    <ul>
                        <li>Report invites: list, create, delete</li>
                        <li>Report read receipts: list</li>
                        <li>Report vulnerabilities: list, create, update, delete</li>
                        <li>Report vulnerability actions: list, create, update, delete</li>
                        <li>Report vulnerability retest requests: list, create, update, delete</li>
                        <li>Report vulnerability client notifications: create</li>
                    </ul>
                </li>
            </ul>
            <Card.Subtitle>Super admin</Card.Subtitle>
            <ul>
                <li>All permissions</li>
            </ul>
        </Card.Body>
    </Card>
);
